module.exports = __webpack_public_path__ + "assets/landing_page_2880x600.76143b78d7755b7cd63de4ebba15580b.jpg";